export default __webpack_public_path__ + "static/media/user.53d66afd.svg";